export const HIJACKED_USER_ID_QUERY_ARG = 'hijackedUserId';
